import React from 'react';
import { BoxWithText, Text } from './StorageInfo.styled';
import { Info } from 'shared/svg/info';

interface StorageInfoProps {
    text: string;
}

export const StorageInfo = ({ text }: StorageInfoProps) => {
    return (
        <BoxWithText>
            <div>
                <Info />
            </div>
            <Text>{text}</Text>
        </BoxWithText>
    );
};
